import logo from '../../Assets/LOGO_BIND_TRACK-07.png'
import { LiaFacebookSquare } from "react-icons/lia";
import { FaInstagram } from "react-icons/fa";
import { RiYoutubeLine } from "react-icons/ri";
import { CiLinkedin } from "react-icons/ci";
import bindflowLogo from "../../Assets/bindflow_logo.png";

import * as S from './Footer.style'

export const Footer = () => {

  const handleMenuClick = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }


  return (
    <S.ContentBox>
      <S.CardsBox className="">
        <S.ImageBox >
          <img src={logo} alt="logo" />
        </S.ImageBox>

        <S.Card>
          <S.TitleCard
            className="">
            Menu
          </S.TitleCard>

          <div className="flex flex-col justify-between h-full">
            <S.Btn
              onClick={() => handleMenuClick("Benefits")}
            >
              DESAFIOS
            </S.Btn>
            <S.Btn
              onClick={() => handleMenuClick("Solution")}
            >
              SOLUÇÃO
            </S.Btn>
            <S.Btn
              onClick={() => handleMenuClick("Operation")}
            >
              COMO FUNCIONA
            </S.Btn>
            <S.Btn
              onClick={() => handleMenuClick("Implementation")}
            >
              IMPLEMENTAÇÃO
            </S.Btn>
            <S.Btn
              onClick={() => handleMenuClick("Contact")}
            >
              CONTATO
            </S.Btn>
          </div>
        </S.Card>

        <S.Card >
          <S.TitleCard >
            Contact us
          </S.TitleCard>

          <div className="flex flex-col justify-between h-full">
            <div className="flex gap-4 mb-2">

              <a
                href="https://www.linkedin.com/company/bindtrack/"
                target="_blank"
                rel="noreferrer">
                <CiLinkedin size={35} />
              </a>

              <a
                href="https://web.facebook.com/profile.php?id=61571760347173"
                target="_blank"
                rel="noreferrer">
                <LiaFacebookSquare size={35} />
              </a>

              <a
                href="https://www.instagram.com/bindtrack/"
                target="_blank"
                rel="noreferrer">
                <FaInstagram size={35} />
              </a>

              <a
                href="https://www.youtube.com/@BindtrackTechnologies"
                target="_blank"
                rel="noreferrer">
                <RiYoutubeLine size={35} />
              </a>

            </div>

            <p className='text-lg'>+55 41 99820-2533</p>
            <p className='text-lg'>contato@bindflow.com.br</p>
            <p className='text-lg'>R. Imaculada Conceição, 1430. 2° andar - Curitiba | PR</p>
          </div>
        </S.Card>
      </S.CardsBox>
      <S.Reserved>
        Todos os direitos reservados
      </S.Reserved>
      <div className='created'>
        <p>Created by</p>
        <img src={bindflowLogo} alt="" />
      </div>
    </S.ContentBox>
  )
}
